jQuery(document).ready(function (e){ 

    $('.site-nav__icons .site-nav__link--icon .icon.icon-search').click(function() {
        $('body').addClass('search_active');
    });
    $('#search-close').click(function() {
        $('body').removeClass('search_active');
    });

    $(document).on('click', '.lubeexplorenow_btn', function (e) {
		e.preventDefault();
		var targetId = $(this).data('target');
		var $target = $('#' + targetId);
		if ($target.length) {
			var headerHeight = $('header').outerHeight() || 0;
			$('html, body').animate({
				scrollTop: $target.offset().top - headerHeight
			}, 800);
		}
	});

    $(document).ready(function() {
        $('.collapsible-que').on('click', function(e) {
            e.preventDefault();
    
            // Remove 'active' class from all question_box elements except the one being clicked
            $('.question_box').not($(this).closest('.question_box')).removeClass('active');
    
            // Close all other collapsible content
            $('.collapsible-cnt').not($(this).next()).slideUp();
            $('.collapsible-que').not(this).removeClass('expanded');
    
            // Toggle the clicked collapsible content and add 'active' class to the clicked question_box
            const $content = $(this).next('.collapsible-cnt');
            $content.slideToggle();
            $(this).toggleClass('expanded');
            $(this).closest('.question_box').toggleClass('active');
        });
    });

});